import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useAddEditorsPick = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: mutateAsyncAddEditorsPick, isPending } = useMutation('addEditorsPick', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['editors-pick'] });
      toast.success(res.message);
      await revalidate(['editorRecommendedStores']);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsyncAddEditorsPick, isPending };
};

export default useAddEditorsPick;
